import { Box, Button, Drawer, Typography } from '@mui/material';
import { PropsWithChildren, useEffect, useState } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import useLocalStorageState from 'src/common/hooks/useLocalStorageState';
import { LocalStorageKeys } from 'src/types/common';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAGS } from 'src/utils/growthBook/growthBook.constants';
import { SECONDARY_LOGO } from 'src/common/constants/brand';

export default function AgeValidationDrawer({ children }: PropsWithChildren) {
  const isAgeConfirmationEnabled = useFeatureIsOn(
    FEATURE_FLAGS.ENABLE_AGE_CONFIRMATION_SCREEN
  );
  const [open, setOpen] = useState(false);
  const [hasAcceptedTerms, setTermsAcceptance] = useLocalStorageState(
    LocalStorageKeys.TermsAcceptance,
    false
  );

  useEffect(() => {
    if (!hasAcceptedTerms && isAgeConfirmationEnabled) {
      setOpen(true);
    }
  }, [hasAcceptedTerms, isAgeConfirmationEnabled]);

  const handleAccept = () => {
    if (isAgeConfirmationEnabled) {
      setTermsAcceptance(true);
      setOpen(false);
    }
  };

  const handleReject = async () => {
    if (isAgeConfirmationEnabled) {
      setTermsAcceptance(false);

      const platform = Capacitor.getPlatform();

      if (platform !== 'android') {
        window.location.href = 'https://www.pari.mx/';
      } else {
        await App.exitApp();
      }
    }
  };

  return open ? (
    <Drawer
      open={open}
      SlideProps={{ timeout: 20 }}
      variant="persistent"
      sx={{
        width: '100%',
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          minWidth: '100vw',
          top: 0,
          border: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: (theme) => theme.palette.common.black,
          minHeight: '100vh',
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent={'space-around'}
        m="auto"
        height="100%"
        pb={5}
        pt={11}
      >
        <Box width="200px" maxWidth="70%" mb={8}>
          <img src={SECONDARY_LOGO} alt="pari logo" width="100%" />
        </Box>
        <Typography
          variant="h1"
          color="white"
          textAlign="center"
          fontFamily="Gotham"
          fontWeight={400}
          fontSize="3rem!important"
          mb={4}
        >
          ¡Importante!
        </Typography>
        <Typography
          variant="body1"
          color="white"
          textAlign="center"
          fontSize={'12px!important'}
          fontFamily="BentonSans"
          fontWeight={700}
          lineHeight={'12px'}
          mb={5}
          sx={{ maxWidth: '265px' }}
        >
          En PARI nos preocupamos por el consumo responsable y prevenimos la
          venta de alcohol a menores, te pedimos contestar con absoluta
          responsabilidad.
        </Typography>
        <Button
          onClick={handleAccept}
          variant="contained"
          color="primary"
          size="large"
          sx={{
            fontFamily: 'BentonSans',
            fontSize: '12px',
            fontWeight: 700,
            mx: 'auto',
            px: 3,
          }}
        >
          Entrar, soy mayor de 18 años
        </Button>
        <Button
          onClick={handleReject}
          variant="text"
          size="large"
          sx={{
            fontFamily: 'BentonSans',
            fontWeight: 700,
            mx: 'auto',
            color: 'gray',
            fontSize: '10px',
            mt: 1,
          }}
        >
          Salir, soy menor de 18 años.
        </Button>
        <Box display="flex" gap={2} mt="auto">
          <a
            href="https://www.pari.mx/aviso-de-privacidad"
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              fontSize="12px!important"
              textAlign="center"
              color="gray"
            >
              Aviso de privacidad
            </Typography>
          </a>
          <a
            href="https://www.pari.mx/terminos-y-condiciones"
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              fontSize="12px!important"
              textAlign="center"
              color="gray"
              fontWeight={400}
            >
              Términos y Condiciones
            </Typography>
          </a>
        </Box>
      </Box>
    </Drawer>
  ) : (
    children
  );
}
